import { KNIT_BEANIE_TEXT } from "../4-one-of-one/_selectors";
import selectAllElements from "../dom/selectAllElements";
import { showOrHideElements } from "../dom/showOrHideElements";

export function getBeanieTextDivs() {
	return {
		get() {
			return selectAllElements<HTMLDivElement>(KNIT_BEANIE_TEXT);
		},
		show() {
			showOrHideElements({ elements: this.get(), show: true });
		},
		hide() {
			showOrHideElements({ elements: this.get(), show: false });
		},
	};
}
